import { render, staticRenderFns } from "./FeedReviews.vue?vue&type=template&id=0269fd80&scoped=true&"
import script from "./FeedReviews.vue?vue&type=script&lang=ts&"
export * from "./FeedReviews.vue?vue&type=script&lang=ts&"
import style0 from "./FeedReviews.vue?vue&type=style&index=0&id=0269fd80&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0269fd80",
  null
  
)

export default component.exports